
import { Layout } from "./Components/Layout";
import { Home } from "./Pages";

function App() {
  return (
    <Layout>
      <Home />
    </Layout>
  );
}

export default App;
